import { render } from "./completeThankyou.vue?vue&type=template&id=1038c27c&lang=true"
import script from "./completeThankyou.vue?vue&type=script&lang=js"
export * from "./completeThankyou.vue?vue&type=script&lang=js"

import "./completeThankyou.vue?vue&type=style&index=0&id=1038c27c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__